module.exports = __webpack_public_path__ + "static/autograph-white-a90e47ca41368bf420bbdc32aba0a0c4.png";